import type { CareerItem, EducationItem } from '../../../../types/application';

// 자기소개서 문항
export interface SelfIntroItem {
  question: string;
  answer: string;
}

// 사역 포트폴리오 — 설교영상 / 찬양영상 / 사역사진
export const PORTFOLIO_CATEGORIES = ['설교영상', '찬양영상', '사역사진'] as const;
export type PortfolioCategory = (typeof PORTFOLIO_CATEGORIES)[number];

export interface PortfolioItem {
  category: PortfolioCategory;
  title: string;
  church: string;
  date: string;
  description: string;
  // 영상 링크 (사역사진은 빈 값)
  link: string;
  // 영상은 썸네일, 사역사진은 사진 원본
  image: string;
}

// 사역자정보 목록 아이템 (GET /resume/ministerlist) — 연락처 제외, 이름 마스킹
export interface MinisterInfoListItem {
  id: string;
  title: string;
  maskedName: string;
  // 공개범위 — 목록에는 모두 나오고 상세 열람만 제한 (PUBLIC | APPLIED | PRIVATE)
  visibility?: string;
  gender: string;
  ageText: string;
  region: string;
  profileImage: string;
  educationItems: EducationItem[];
  careerItems: CareerItem[];
  hopeType: string;
  hopeLocation: string;
  hopeRoles: string;
  hopeDepartment: string;
  updatedAt: string;
  hasSelfIntroduction?: boolean;
  portfolioCount?: number;
}

// 사역자정보 상세 (GET /resume/ministerdetail/:resumeId)
export interface MinisterInfoDetail {
  id: string;
  // 교회 담당자가 아닌 회원에게 내려오는 모자이크용 치환 데이터
  masked?: boolean;
  title: string;
  name: string;
  gender: string;
  birthYear: string;
  birthMonth: string;
  birthDay: string;
  ageText: string;
  phone: string;
  email: string;
  address: string;
  addressDetail: string;
  profileImage: string;
  educationItems: EducationItem[];
  careerItems: CareerItem[];
  hopeType: string;
  hopeLocation: string;
  hopeSalary: string;
  hopeSalaryPaySort: string;
  hopeRoles: string;
  hopeDepartment: string;
  hopeInsurance: string;
  hopeWelfare: string;
  updatedAt: string;
  selfIntroduction?: SelfIntroItem[];
  portfolioItems?: PortfolioItem[];
}
